(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subscribe', {
            parent: 'entity',
            url: '/subscribe',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.subscribe.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscribe/subscribes.html',
                    controller: 'SubscribeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subscribe');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('subscribe-detail', {
            parent: 'subscribe',
            url: '/subscribe/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.subscribe.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscribe/subscribe-detail.html',
                    controller: 'SubscribeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subscribe');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Subscribe', function($stateParams, Subscribe) {
                    return Subscribe.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'subscribe',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('subscribe-detail.edit', {
            parent: 'subscribe-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscribe/subscribe-dialog.html',
                    controller: 'SubscribeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Subscribe', function(Subscribe) {
                            return Subscribe.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscribe.new', {
            parent: 'subscribe',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscribe/subscribe-dialog.html',
                    controller: 'SubscribeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                notificationRemiderId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subscribe', null, { reload: 'subscribe' });
                }, function() {
                    $state.go('subscribe');
                });
            }]
        })
        .state('subscribe.edit', {
            parent: 'subscribe',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscribe/subscribe-dialog.html',
                    controller: 'SubscribeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Subscribe', function(Subscribe) {
                            return Subscribe.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscribe', null, { reload: 'subscribe' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscribe.delete', {
            parent: 'subscribe',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscribe/subscribe-delete-dialog.html',
                    controller: 'SubscribeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Subscribe', function(Subscribe) {
                            return Subscribe.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscribe', null, { reload: 'subscribe' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
